export default function preloaderStart (scene) {

	scene.load.image('menu', '/img/menu.png');
	scene.load.image('buttonPlay', '/img/button-play.png');
	scene.load.image('buttonAbout', '/img/about.png');

	scene.load.image('walkRight', '/img/generalSprites/buttonsMobile/right.png');
	scene.load.image('walkLeft', '/img/generalSprites/buttonsMobile/left.png');
	scene.load.image('walkUp', '/img/generalSprites/buttonsMobile/up.png');
	scene.load.image('walkDown', '/img/generalSprites/buttonsMobile/down.png');
	scene.load.image('buttonAction', '/img/generalSprites/buttonsMobile/o.png');

	scene.load.spritesheet(`jiu-start`, 
		`/img/start/jiu.png`,
		{ frameWidth: 39, frameHeight: 41 }	);

	scene.load.audio("jiuSolo", ["/audio/solos/jiu.mp3"]);
	scene.load.audio("suaSolo", ["/audio/solos/sua.mp3"]);
	scene.load.audio("siyeonSolo", ["/audio/solos/siyeon.mp3"]);
	scene.load.audio("handongSolo", ["/audio/solos/handong.mp3"]);
	scene.load.audio("yoohyeonSolo", ["/audio/solos/yoohyeon.mp3"]);
	scene.load.audio("damiSolo", ["/audio/solos/dami.mp3"]);
	scene.load.audio("gahyeonSolo", ["/audio/solos/gahyeon.mp3"]);

	scene.load.spritesheet(`sua-start`, 
		`/img/start/sua.png`,
		{ frameWidth: 39, frameHeight: 41 }	);

	scene.load.spritesheet(`siyeon-start`, 
		`/img/start/siyeon.png`,
		{ frameWidth: 39, frameHeight: 41 }	);
	
	scene.load.spritesheet(`handong-start`, 
		`/img/start/handong.png`,
		{ frameWidth: 39, frameHeight: 41 }	);
	
	scene.load.spritesheet(`yoohyeon-start`, 
		`/img/start/yoohyeon.png`,
		{ frameWidth: 39, frameHeight: 41 }	);

	scene.load.spritesheet(`dami-start`, 
		`/img/start/dami.png`,
		{ frameWidth: 39, frameHeight: 41 }	);
	
	scene.load.spritesheet(`gahyeon-start`, 
		`/img/start/gahyeon.png`,
		{ frameWidth: 39, frameHeight: 41 }	);
}